<template>
  <div :class="['transition-all', is_collapsed ? 'w-14' : 'w-48', 'bg-white shadow h-full']">
    <div class="flex justify-end p-2">
      <button @click="toggle">
        <i :class="is_collapsed ? 'mdi mdi-chevron-right' : 'mdi mdi-chevron-left'"></i>
      </button>
    </div>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="nav-item"
      @click="select(index, item)"
    >
      <i
        :class="[
          'mdi',
          item.icon,
          'nav-icon',
          selected_index === index ? 'text-blue-500' : 'text-gray-400'
        ]"
      ></i>
      <span
        v-if="!is_mobile && !is_collapsed"
        :class="['nav-text', selected_index === index ? 'font-bold' : '']"
      >
        {{ item.text }}
      </span>
    </div>

  </div>
</template>

<script>
export default {
  name: 'MemlistNavigationDrawer',
  props: {
    items: Array,
  },
  data() {
    return {
      selected_index: 0,
      is_collapsed: false,
      is_mobile: window.innerWidth < 768,
    };
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    toggle() {
      this.is_collapsed = !this.is_collapsed;
    },
    handleResize() {
      this.is_mobile = window.innerWidth < 768;
    },
    select(index, item) {
      this.selected_index = index;
      this.$emit('clicked', { index, text: item.text, value: item.value });
    }
  },
};
</script>

<style scoped>
@import url('https://cdn.jsdelivr.net/npm/@mdi/font/css/materialdesignicons.min.css');

.text-blue-500 {
  color: #3699FF;
}

.text-3xl {
  font-size: 2rem;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #e5e7eb;
  transition: background 0.2s;
}

.nav-item:hover {
  background-color: #f3f4f6;
}

.nav-icon {
  font-size: 2rem;
  min-width: 2.5rem;
  text-align: center;
}

.nav-text {
  white-space: nowrap;
  margin-left: 0.25rem;
  min-width: 200px;
}

.text-blue-500 {
  color: #3699FF;
}

.text-gray-400 {
  color: #9ca3af;
}

.font-bold {
  font-weight: 700;
}

</style>
